import { Box, Button, IconButton, Paper, Typography } from '@mui/material'
import { TooltipRenderProps } from 'react-joyride'
import { CloseIcon } from 'src/v3/core/icons'
import { paletteColorsDark } from 'src/theme'

export let TourTooltip = ({
  index,
  isLastStep,
  size,
  step,
  backProps,
  closeProps,
  primaryProps,
  skipProps,
  tooltipProps,
}: TooltipRenderProps) => (
  <Paper
    {...tooltipProps}
    elevation={8}
    sx={{
      bgcolor: paletteColorsDark.background.paper,
      border: '1px solid rgba(255,255,255,0.08)',
      borderRadius: 2,
      p: 3,
      width: 440,
      maxWidth: '92vw',
      boxShadow: '0 16px 48px rgba(0,0,0,0.7)',
    }}
  >
    {/* Header */}
    <Box
      sx={{
        display: 'flex',
        alignItems: 'flex-start',
        gap: 1,
        mb: step.title ? 2 : 0,
      }}
    >
      {step.title && (
        <Typography
          variant="h6"
          sx={{
            flex: 1,
            fontWeight: 600,
            color: '#fff',
            fontSize: 17,
            lineHeight: 1.3,
          }}
        >
          {step.title}
        </Typography>
      )}
      <IconButton
        {...closeProps}
        size="small"
        sx={{
          color: 'rgba(255,255,255,0.4)',
          mt: -0.5,
          mr: -0.5,
          '&:hover': { color: '#fff' },
        }}
      >
        <CloseIcon sx={{ fontSize: 18 }} />
      </IconButton>
    </Box>

    {/* Content */}
    <Box sx={{ mb: 3 }}>
      {typeof step.content === 'string' ? (
        <Typography
          variant="body2"
          sx={{ color: paletteColorsDark.text, lineHeight: 1.75, opacity: 0.9 }}
        >
          {step.content}
        </Typography>
      ) : (
        step.content
      )}
    </Box>

    {/* Footer */}
    <Box
      sx={{
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-between',
      }}
    >
      <Button
        {...skipProps}
        size="small"
        sx={{
          color: 'rgba(255,255,255,0.35)',
          textTransform: 'none',
          fontSize: 13,
          p: 0,
          minWidth: 0,
          '&:hover': { color: 'rgba(255,255,255,0.6)', background: 'none' },
        }}
        disableRipple
      >
        Skip tour
      </Button>

      <Box sx={{ display: 'flex', alignItems: 'center', gap: 1.5 }}>
        {/* Step dots */}
        <Box sx={{ display: 'flex', gap: 0.75 }}>
          {Array.from({ length: size }).map((_, i) => (
            <Box
              key={i}
              sx={{
                width: 6,
                height: 6,
                borderRadius: '50%',
                bgcolor:
                  i === index
                    ? paletteColorsDark.primary
                    : 'rgba(255,255,255,0.2)',
                transition: 'background-color 0.2s',
              }}
            />
          ))}
        </Box>

        {index > 0 && (
          <Button
            {...backProps}
            size="small"
            sx={{
              color: paletteColorsDark.text,
              textTransform: 'none',
              fontSize: 13,
              opacity: 0.7,
              '&:hover': { opacity: 1, background: 'none' },
            }}
            disableRipple
          >
            Back
          </Button>
        )}

        <Button
          {...primaryProps}
          variant="contained"
          size="small"
          disableFocusRipple
          sx={{
            textTransform: 'none',
            fontSize: 13,
            borderRadius: 1,
            px: 2,
            fontWeight: 600,
          }}
        >
          {isLastStep ? 'Done' : 'Next'}
        </Button>
      </Box>
    </Box>
  </Paper>
)
